// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2e7d32', // Sattes Grün
    },
    secondary: {
      main: '#ffa000', // Kräftiges Gelb/Orange
    },
    success: {
      main: '#388e3c',
      dark: '#2e7d32',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#333333',
      secondary: '#555555',
    },
  },
  typography: {
    fontFamily: ['Nunito', 'sans-serif'].join(','),
    h1: {
      fontFamily: "'Anton', sans-serif",
      fontSize: '4rem',
      fontWeight: 400,
      textTransform: 'uppercase',
      color: '#ffffff',
      textShadow: '2px 2px 5px rgba(0, 0, 0, 0.5)',
    },
    h2: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 700,
      fontSize: '2.5rem',
      lineHeight: 1.25,
    },
    h3: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 700,
      fontSize: '2rem',
      lineHeight: 1.3,
    },
    h4: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 600,
      fontSize: '1.75rem',
      lineHeight: 1.3,
    },
    h5: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: 1.4,
    },
    h6: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: 1.4,
    },
    subtitle1: {
      fontFamily: 'Nunito, sans-serif',
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.6,
    },
    subtitle2: {
      fontFamily: 'Nunito, sans-serif',
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    body1: {
      fontFamily: 'Nunito, sans-serif',
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.6,
    },
    body2: {
      fontFamily: 'Nunito, sans-serif',
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    button: {
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '1rem',
      fontWeight: 600,
      textTransform: 'none',
      lineHeight: 1.2,
    },
    caption: {
      fontFamily: 'Nunito, sans-serif',
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: 1.4,
    },
    overline: {
      fontFamily: 'Nunito, sans-serif',
      fontSize: '0.75rem',
      fontWeight: 700,
      letterSpacing: '1px',
      textTransform: 'uppercase',
      lineHeight: 1.4,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          // Beispiel: Abgerundete Ecken und Schatten
          borderRadius: 0,
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        },
      },
    },
    // Responsive Tabellen für mobile Geräte
    MuiTableContainer: {
      styleOverrides: {
        root: {
          overflowX: 'auto',
          WebkitOverflowScrolling: 'touch',
          '&::-webkit-scrollbar': {
            height: 8,
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'rgba(0,0,0,0.05)',
            borderRadius: 4,
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,0.2)',
            borderRadius: 4,
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.3)',
            },
          },
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          minWidth: 500, // Standardmindestbreite für Tabellen
        },
      },
    },

    // Andere Komponenten wie MuiCard, MuiButton etc.
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 0, // Gerade Ecken für alle Karten
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', // Sanfter Schatten
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 20, // Pillenform für Buttons
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 0, // Gerade Ecken für Paper-Komponenten
        },
      },
    },
  },
});

export default theme;
